import $ from 'jquery';
import rivets from 'rivets';
import { reload } from '../../../validation/validation-controller';
import InputsetB2bCompanyModel from '../../../layout/b2b/inputsetB2bCompanyModel';
import InputsetB2bCompanyView from '../../../layout/b2b/inputsetB2bCompanyView';
import ItalianTaxId from '../../../layout/italianTaxId';
import PhoneNumberFormatter from '../../../layout/phoneNumberFormatterView';
import AddressFormModel from '../../../pages/myAccount/profile/addressFormModel';
import BaseView from '../../../pages/myAccount/profile/BaseView';

export default BaseView.extend({
  selectors: {
    companyInputset: '.js-inputset-b2b-company',
    defaultBillingAddressCheckboxWrapper:
      '.js-address-form-billing-address-checkbox-wrapper',
    defaultBillingAddressCheckbox: '.js-address-form-billing-address-checkbox',
    phoneField: '[name="telephone"]',
    hiddenClass: 'is-hidden',
    taxId: '.js-tax-id input'
  },

  events: {
    'change .js-address-form-billing-address-checkbox': 'onCheckboxChange'
  },

  initialize: function(options) {
    /* istanbul ignore else */
    if (options && options.scope) {
      this.$scope = options.scope;
    } else {
      this.$scope = $('body');
    }

    this.model = new AddressFormModel();
    this.inputsetB2bCompanyModel = new InputsetB2bCompanyModel();

    this.$defaultBillingAddressCheckboxWrapper = this.$el.find(
      this.selectors.defaultBillingAddressCheckboxWrapper
    );
    this.$defaultBillingAddressCheckbox = this.$el.find(
      this.selectors.defaultBillingAddressCheckbox
    );
    this.inputsetB2bCompanyModel.set(
      'isCheckedBillingAddressCheckbox',
      Boolean(this.$defaultBillingAddressCheckbox.prop('checked'))
    );

    new InputsetB2bCompanyView({
      el: this.$el.find(this.selectors.companyInputset),
      model: this.inputsetB2bCompanyModel
    });

    new PhoneNumberFormatter({
      el: this.$el.find(this.selectors.phoneField)
    });

    this.$taxId = this.$el.find(this.selectors.taxId);

    if (this.$taxId) {
      this.taxId = new ItalianTaxId({
        el: this.$taxId
      });
    }

    this.setupRivetsBindings();
    this.bindEvents();
    reload();
  },

  bindEvents: function() {
    this.listenTo(
      this.inputsetB2bCompanyModel,
      'change:hiddenInputValue',
      this.onChangeValue,
      this
    );
    if (this.$taxId.length) {
      this.listenTo(this.model, 'change:showTaxId', this.onShowTaxId, this);
    }
  },

  setupRivetsBindings: function() {
    rivets.bind(this.$el, {
      viewModel: this.model
    });
  },

  onChangeValue: function(model, value) {
    if (value === model.get('customerCompanyValue')) {
      this.showCheckbox();
    } else {
      this.hideCheckbox();
    }
  },

  onCheckboxChange: function(e) {
    this.inputsetB2bCompanyModel.set(
      'isCheckedBillingAddressCheckbox',
      Boolean($(e.target).prop('checked'))
    );
  },

  showCheckbox: function() {
    this.$defaultBillingAddressCheckboxWrapper.removeClass(
      this.selectors.hiddenClass
    );
    this.$defaultBillingAddressCheckbox.prop(
      'checked',
      this.inputsetB2bCompanyModel.get('isCheckedBillingAddressCheckbox')
    );
  },

  hideCheckbox: function() {
    this.$defaultBillingAddressCheckboxWrapper.addClass(
      this.selectors.hiddenClass
    );
    this.$defaultBillingAddressCheckbox.prop('checked', false);
  },

  onShowTaxId: function(model, value) {
    if (this.$taxId) {
      this.$taxId.attr('data-validate', value);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/addressFormView.js
 **/